import { render, staticRenderFns } from "./CoordinateMapper.vue?vue&type=template&id=2cd22159"
import script from "./CoordinateMapper.vue?vue&type=script&lang=js"
export * from "./CoordinateMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports